import { initTracerError, initTracerErrorUploader, initTracerLog } from '@apptracer/sdk/lite';

import { packageName, packageVersion, tracerAppToken } from '../../../config';

const componentName = 'vks-chat-widget';

export const initTracer = () => {
  const config = {
    versionName: `${packageName}_${packageVersion}`,
    versionCode: 1,
    appToken: tracerAppToken,
    environment: 'production',
  };

  // Подписываемся на глобальные события ошибок
  initTracerError(componentName, {
    enableUnhandledErrorsListeners: true,
  });

  initTracerLog(componentName);

  // Инициализируем Трейсер для отправки зарегистрированных ошибок
  initTracerErrorUploader(componentName, config);
};
